import React, { FC, useCallback, useState } from 'react';
import { CountdownCircleTimer, Props, TimeProps } from 'react-countdown-circle-timer';

import {
  ClockContainer,
  ClockTime,
  IClockContainer,
  LittleClockContainer,
  TimeContainer,
} from './styles';

export type ITimerClock = Omit<
  IClockContainer & Props & { title: string },
  'colors' | 'size' | 'rotation'
>;

const TimerClockCircle: FC<ITimerClock> = ({
  $isDark,
  $isActive,
  $isBlinking,
  $isMainClock,
  title,
  ...props
}) => {
  const [timeStr, setTimeStr] = useState('');
  const [isActiveBlinking, setIsActiveBlinking] = useState(false);

  const renderTime = useCallback(
    ({ remainingTime }: TimeProps) => {
      if (remainingTime <= 10) {
        setIsActiveBlinking(true);
      }

      const minutes = Math.floor(remainingTime / 60);
      const displayMinutes = minutes < 10 ? `0${minutes}` : minutes;

      const seconds = Math.floor(remainingTime - minutes * 60);
      const displaySeconds = seconds < 10 ? `0${seconds}` : seconds;
      setTimeStr(`${displayMinutes}:${displaySeconds}`);
      return (
        <ClockTime
          $isDark={$isDark}
          $isMainClock={$isMainClock}
        >
          {displayMinutes}:{displaySeconds}
        </ClockTime>
      );
    },
    [$isDark],
  );

  return (
    <ClockContainer
      $isDark={$isDark}
      $isBlinking={isActiveBlinking && $isBlinking}
    >
      <TimeContainer $isActive={$isActive}>
        <CountdownCircleTimer
          {...props}
          colors={'#ffffff' as any}
          size={$isMainClock ? 0 : 260}
          isGrowing={$isMainClock ? false : true}
          rotation="counterclockwise"
        >
          {renderTime}
        </CountdownCircleTimer>
      </TimeContainer>
      <LittleClockContainer $isActive={$isActive}>{timeStr}</LittleClockContainer>
    </ClockContainer>
  );
};

export default TimerClockCircle;
